import * as Styled from "./LiveEventWelcomeModal.styles";

import { Box, Typography, useTheme } from "@mui/material";

import BaseModal from "../BaseModal/BaseModal";
import { useState } from "react";

type LiveEventWelcomeModalProps = {
  open: any;
  onClose: any;
};

const LiveEventWelcomeModal = ({
  open,
  onClose,
}: LiveEventWelcomeModalProps) => {
  const theme = useTheme();
  const [hovered, setHovered] = useState(false);
  return (
    <BaseModal open={open} onClose={onClose} showCloseButton={false}>
      <Box style={{ textAlign: "center" }}>
        <Styled.CelebrationIcon fill={theme.colors.primary.slalomBlue} />
        <Styled.ModalTitleContainer>
          <Typography variant="h2">Welcome to the party</Typography>
        </Styled.ModalTitleContainer>
        <Typography
          variant="modalSubtitle"
          style={{ marginBottom: theme.spacing(2) }}
        >
          You're now checked-in to the live event. Enjoy!
        </Typography>
        <Typography variant="body2">
          {`Gather is intended for internal use only. If a non-employee appears in
          any of your photos, please ensure they complete Slalom's Media Release
          Form, which is accessible `}
          <span
            style={{
              color: theme.colors.primary.slalomBlue,
              textDecoration: "underline",
              cursor: "pointer",
              transition: "opacity 0.3s ease",
              opacity: hovered ? 0.7 : 1,
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={() => {
              window.open(
                "https://slalom1.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhAQGijvLN7znz6NyODCVKpcLGqdP-FohfL3JzXnLpRcfJmbmeZUdWU2iQ4JEN9x4Bk",
                "_blank"
              );
            }}
          >
            here
          </span>
          {". This ensures compliance with Slalom’s media policies (found "}
          <span
            style={{
              color: theme.colors.primary.slalomBlue,
              textDecoration: "underline",
              cursor: "pointer",
              transition: "opacity 0.3s ease",
              opacity: hovered ? 0.7 : 1,
            }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={() => {
              window.open(
                "https://twodegrees1.sharepoint.com/teams/marketing/SiteAssets/Forms/AllItems.aspx?id=%2Fteams%2Fmarketing%2FSiteAssets%2FMedia%20release%2FMedia%20Release%20%2D%20Requirements%20and%20Guidance%20%286%2E2024%29%2Epdf&parent=%2Fteams%2Fmarketing%2FSiteAssets%2FMedia%20release",
                "_blank"
              );
            }}
          >
            here
          </span>
          {")"}
        </Typography>
        <Styled.ConfirmButton
          variant="contained"
          fullWidth
          size="large"
          onClick={() => {
            onClose();
          }}
        >
          Sounds good, let's go!
        </Styled.ConfirmButton>
      </Box>
    </BaseModal>
  );
};

export default LiveEventWelcomeModal;
